import { render, staticRenderFns } from "./InstallDrawer.vue?vue&type=template&id=20e38aac&"
import script from "./InstallDrawer.vue?vue&type=script&lang=js&"
export * from "./InstallDrawer.vue?vue&type=script&lang=js&"
import style0 from "./InstallDrawer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports